<template>
    <a href='https://play.google.com/store/apps/details?id=com.avenlabs.conclave'>
        <img class="store-badge" alt='Get it on Google Play' src="../assets/google_play_store.png"/>
    </a>
</template>